import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal, Button, Row, Col, Avatar, Tag
} from 'antd';
 
import styles from './ViewCreatedUser.module.less'; 
import { useTranslation } from 'react-i18next';
 

const imagePath = 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/2048px-User-avatar.svg.png';

function Usuarios({
  isModalVisible,
  setIsModalVisible,
  modalData,
}) {
  const { t } = useTranslation(); 

  return (
    <Modal
      centered
      width={350}
      visible={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={[ 
        <Button key="button" type="primary" onClick={() => setIsModalVisible(false)} >
          {t('common.accept')}
        </Button>
      ]} 
    >
     <div>
      {/* Primera fila */}
      <Row gutter={16} align="middle">
        <Col span={24} style={{textAlign:'center'}}>
          <Avatar 
          src={imagePath}
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            marginRight: 10,
            background: '#eae4e4',
          }} />
        </Col>
        <Col span={24} style={{textAlign:'center',marginTop:10}}>
          <h2 style={{marginBottom:0}}>{t('forms.users.feedbacks.create_success')}</h2>
          <span className={styles.spacingSubText}>{t('forms.users.feedbacks.create_success_inbox', { mail: 'test@test.com' })}</span>
        </Col>
      </Row> 
    </div>
 
    </Modal>
  );

}
Usuarios.propTypes = {
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func.isRequired,
  modalData: PropTypes.object,
};

Usuarios.defaultProps = {
  isModalVisible: false,
  modalData: {},
};

export default Usuarios;
